// 弃用，某种原因不能在web上登录，只能在app上
import React from 'react'
import { withRouter } from 'react-router-dom'
import { Button, Form, Input } from 'antd-mobile'
import { Wrapper, Container, Header } from '../../components_renew/Layout'
import { handleResponse } from '../../utils'
import { request } from '../../requests/request'
// import imgUser from '../../assets/img/login-user.png'
// import imgTicket from '../../assets/img/login-ticket.png'
// import imgLabel1 from '../../assets/img/login-label1.png'
// import imgLabel2 from '../../assets/img/login-label2.png'

// class CaptCha extends React.PureComponent {
//   static defaultProps = {
//     children: '获取验证码',
//     count: 16,
//     formatter: function (count) {
//       return `${count}s`
//     },
//     onStart: function () { return new Promise((resolve) => {resolve()})}
//   }
//
//   state = {
//     counting: false,
//     count: this.props.count
//   }
//
//   interval = null
//
//   render () {
//     const { children, formatter } = this.props
//     const { counting, count } = this.state
//     return <div className={'login__captcha'} onClick={this.onClick}>
//       {
//         counting
//           ? formatter(count)
//           : children
//       }
//     </div>
//   }
//
//   onClick = () => {
//     if (!this.state.counting) {
//       this.props.onStart()
//         .then((res) => {
//           console.log('on start promise then', res)
//           this.startCounting()
//         })
//         .catch(error => {
//           console.error(error)
//           window.toast.fail(error.message)
//         })
//     }
//   }
//
//   startCounting = () => {
//     clearInterval(this.interval)
//     let handler = () => {
//       const { count } = this.state
//       if (count === 0) {
//         clearInterval(this.interval)
//         this.setState({
//           counting: false,
//           count: this.props.count
//         })
//       } else {
//         this.setState({
//           counting: true,
//           count: count - 1
//         })
//       }
//     }
//     handler()
//     this.interval = setInterval(handler, 1000)
//   }
//
// }

@withRouter
class Login extends React.PureComponent {
  state = {
    phone: '15600000001',
    // phone: '12200000000',
    captcha: '56081095',
  }

  componentDidMount () {
    if (sessionStorage.getItem('token')) {

    }
  }

  render () {
    const { phone, captcha } = this.state
    return <Container>
      <Header>注册登陆</Header>
      <Wrapper className={'login__wrapper'}>
        <Form layout={'horizontal'}>
          <Form.Item label={'phone'}>
            <Input value={phone} onChange={v => this.setState({ phone: v })}></Input>
          </Form.Item>
          <Form.Item label={'captcha'}>
            <Input value={captcha} onChange={v => this.setState({ captcha: v })}></Input>
          </Form.Item>
        </Form>
        <div className={'p-4 text-right'}>
          <Button onClick={this.login}>LOGIN</Button>
        </div>
      </Wrapper>
    </Container>
  }

  login = () => {
    const { phone, captcha } = this.state
    const config = {
      method: 'post',
      url: window.API.User.postLoginRequest,
      data: {
        username: phone,
        captcha
      }
    }
    window.toast.loading('请求中...')
    window.axios(config).then(handleResponse())
      .then(res => {
        window.axios.setToken(res['token'])
        request.setToken(res['token'])
        // window.postMessage(JSON.stringify({ type: 'login', data: res['token'] }), '*')
        // postMessage({ type: window.POST_TYPE.LOGIN, data: res['token'] })
        window.toast.success('登陆成功', 2, () => {

        })
      })
      .catch(error => {
        console.error(error)
        window.toast.fail(error.message)
      })
  }

  // postCaptchaRequest = () => {
  //   const phone = this.refs['phone'].value
  //   return new Promise((resolve, reject) => {
  //     if (!phone) {
  //       reject({ message: '请填写手机号码' })
  //       return
  //     }
  //     let config = {
  //       method: 'post',
  //       url: window.API.User.postCaptchaRequest(phone)
  //     }
  //     window.axios(config).then(handleResponse()).then((res) => {
  //       window.toast.success('验证码已发送')
  //       resolve()
  //     })
  //       .catch(error => {
  //         if (!error.message) { error.message = '获取验证码失败'}
  //         reject(error)
  //       })
  //   })
  // }

  // requestLogin = () => {
  //   const { phone, captcha } = this.state
  //   if (!phone) return window.toast.fail('请填写手机号')
  //   if (!captcha) return window.toast.fail('请填写验证码')
  //   let config = {
  //     method: 'post',
  //     url: window.API.User.postLoginRequest,
  //     data: {
  //       username: phone,
  //       captcha,
  //       code: captcha
  //     }
  //   }
  //   window.toast.loading('请求中...')
  //   window.axios(config).then(handleResponse())
  //     .then(res => {
  //       window.axios.setToken(res['token'])
  //       // window.postMessage(JSON.stringify({ type: 'login', data: res['token'] }), '*')
  //       postMessage({ type: window.POST_TYPE.LOGIN, data: res['token'] })
  //       window.toast.success('登陆成功', 2, () => {
  //
  //       })
  //     })
  //
  //     .catch(error => {
  //       console.error(error)
  //       window.toast.fail(error.message)
  //     })
  // }

}

export default Login
